import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ResponseDatasEnem } from '../../domain/entities/EnemForm'

interface CountdownEnemProps {
  datasEnem: ResponseDatasEnem
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled.div`
  align-self: center;
  font-family: 'BwMitga', -apple-system, BlinkMacSystemFont, “Segoe UI”, “Roboto”, “Oxygen”, “Ubuntu”, “Cantarell”,
    “Fira Sans”, “Droid Sans”, “Helvetica Neue”, sans-serif;
  font-weight: 900;
  font-size: 1.5rem;
  color: #2e7d32;
  margin-right: 10px;
  letter-spacing: 1px;

  @media (max-width: 768px) {
    flex: 1;
    text-align: center;
    margin: 15px 0;
  }
`

const Timer = styled.div`
  display: flex;
  gap: 1rem;
`

const TimeCard = styled.div`
  background-color: #2e7d32; /* verde escuro mais elegante */
  padding: 1.5rem 1.2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  text-align: center;
  min-width: 80px;
`

const TimeNumber = styled.div`
  font-size: 3rem;
  font-weight: bold;
  color: #e6f6e2; /* verde claro puxando pro branco */
`

const TimeLabel = styled.div`
  font-size: 0.9rem;
  margin-top: 0.4rem;
  color: #d4e6d0; /* cinza esverdeado suave */
`

export const CountdownEnem: React.FC<CountdownEnemProps> = ({ datasEnem }) => {
  const [timeLeft, setTimeLeft] = useState({
    dias: 0,
    horas: 0,
    minutos: 0,
    segundos: 0,
  })

  useEffect(() => {
    if (!datasEnem?.dataInicioParticipacaoSegundaFase) return

    const targetDate = new Date(`${datasEnem.dataInicioParticipacaoSegundaFase.toString().replace('Z', '-03:00')}`).getTime();

    const updateTimer = () => {
      const now = new Date().getTime()
      const difference = targetDate - now

      if (difference > 0) {
        const dias = Math.floor(difference / (1000 * 60 * 60 * 24))
        const horas = Math.floor((difference / (1000 * 60 * 60)) % 24)
        const minutos = Math.floor((difference / (1000 * 60)) % 60)
        const segundos = Math.floor((difference / 1000) % 60)

        setTimeLeft({ dias, horas, minutos, segundos })
      } else {
        setTimeLeft({ dias: 0, horas: 0, minutos: 0, segundos: 0 })
      }
    }

    updateTimer()
    const interval = setInterval(updateTimer, 1000)

    return () => clearInterval(interval)
  }, [datasEnem])

  const format = (value: number) => String(value).padStart(2, '0')

  const isExpired = Object.values(timeLeft).every((value) => value <= 0)

  if (isExpired) {
    return <Container>{/* Cronômetro encerrado */}</Container>
  }

  return (
    <Container>
      <Title>2º dia do Enem</Title>
      <Timer>
        <TimeCard>
          <TimeNumber>{format(timeLeft.dias)}</TimeNumber>
          <TimeLabel>DIAS</TimeLabel>
        </TimeCard>
        <TimeCard>
          <TimeNumber>{format(timeLeft.horas)}</TimeNumber>
          <TimeLabel>HORAS</TimeLabel>
        </TimeCard>
        <TimeCard>
          <TimeNumber>{format(timeLeft.minutos)}</TimeNumber>
          <TimeLabel>MINUTOS</TimeLabel>
        </TimeCard>
        <TimeCard>
          <TimeNumber>{format(timeLeft.segundos)}</TimeNumber>
          <TimeLabel>SEGUNDOS</TimeLabel>
        </TimeCard>
      </Timer>
    </Container>
  )
}
